import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Modals.scss';

function ModalText({ children, checkbox }) {
    return (<span className={styles[`modal${checkbox ? '-checkbox' : ''}-text`]}>
        {children}
    </span>)
}

ModalText.displayName = displayName('Modals/ModalText');

ModalText.propTypes = {
    children: PropTypes.node.isRequired,
    checkbox: PropTypes.bool,
};

ModalText.defaultProps = {
    checkbox: false,
};

export default ModalText;
